import React from 'react';
import PropTypes from 'prop-types';
import AmexExperientialEventsCard from '../../AmexExperiential/AmexExperientialEvents/AmexExperientialEventsCard';

const WrapperExperientialEventsCard = ({
  baseRequestUrl,
  handleTagging,
  Analytics,
  matchMedia,
  taggingConfig,
  eventsContent: {
    experientialEventsConfig: {
      soldout_label: soldoutLabel,
      timezone_mappings: timezoneMappings,
      sold_out_message: soldOutMessage,
    },
    isAuthenticated,
    $rootScope,
    selectedCoreSeats,
    updateParsedEventData,
    showAllEnabled,
  },
  isCarousel,
  eventItem,
  content,
  tabHeading: heading,
}) => (
  <AmexExperientialEventsCard
    key={eventItem.event_id}
    eventData={eventItem}
    baseRequestUrl={baseRequestUrl}
    soldoutLabel={soldoutLabel}
    Analytics={Analytics}
    handleTagging={handleTagging}
    isDesktop={matchMedia.md}
    timezoneMappings={timezoneMappings}
    isAuthenticated={isAuthenticated}
    isCarousel={isCarousel}
    $rootScope={$rootScope}
    selectedCoreSeats={selectedCoreSeats}
    updateParsedEventData={updateParsedEventData}
    soldOutMessage={soldOutMessage}
    tagConfig={taggingConfig}
    tabHeading={heading}
    matchMedia={matchMedia}
    showAllEnabled={showAllEnabled}
    hideSoldOutDisplayFlag={content?.hide_sold_out_display_flag}
    simpleDisplayMode={content?.simple_display_mode}
    displayVenueName={content?.display_venue_name}
  />
);

WrapperExperientialEventsCard.propTypes = {
  eventsContent: PropTypes.shape({
    experientialEvents: PropTypes.arrayOf(PropTypes.shape({
      event_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      event_name: PropTypes.string,
      event_type: PropTypes.number,
      image: PropTypes.string,
      logo: PropTypes.string,
      event_date_time: PropTypes.string,
      display_start_date_time: PropTypes.string,
      display_end_date_time: PropTypes.string,
      image_preview_text: PropTypes.shape({}),
      locations_text: PropTypes.string,
      sold_out: PropTypes.bool,
      event_url: PropTypes.string,
      time: PropTypes.string,
    })).isRequired,
    experientialEventsConfig: PropTypes.shape({
      header_one: PropTypes.string,
      header_two: PropTypes.string,
      soldout_label: PropTypes.string,
      no_events_message: PropTypes.string,
      section_id: PropTypes.string,
      timezone_mappings: PropTypes.shape({}),
      sold_out_message: PropTypes.string,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    $rootScope: PropTypes.shape({
      $broadcast: PropTypes.func,
    }).isRequired,
    selectedCoreSeats: PropTypes.number.isRequired,
    updateParsedEventData: PropTypes.func.isRequired,
    showAllEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  handleTagging: PropTypes.func.isRequired,
  taggingConfig: PropTypes.shape({
    content: PropTypes.shape({
      events: PropTypes.shape({}).isRequired,
    }).isRequired,
  }).isRequired,
  actionConfig: PropTypes.shape({}),
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  eventItem: PropTypes.shape({ event_id: PropTypes.string.isRequired }).isRequired,
  isCarousel: PropTypes.bool,
  content: PropTypes.shape({
    hide_sold_out_display_flag: PropTypes.bool,
    simple_display_mode: PropTypes.bool,
    display_venue_name: PropTypes.bool,
  }),
  tabHeading: PropTypes.string,
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
  }).isRequired,
};

WrapperExperientialEventsCard.defaultProps = {
  isCarousel: false,
  actionConfig: undefined,
  content: {
    hideSoldOutDisplayFlag: false,
    simpleDisplayMode: false,
  },
  tabHeading: '',
};

export default WrapperExperientialEventsCard;
